import React, { useState } from 'react';
import { EditText } from '../../../../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../../../../component/call-to-action-button/call-to-action-button';
import { createNewClassOperations } from '../operations/create-new-class-operations';

interface AddNewClassDialog {
  branchId: number | undefined;
  buildingId: number | undefined;
  closeDialog: () => void;
}

export const AddNewClassDialog: React.FC<AddNewClassDialog> = ({
  branchId,
  buildingId,
  closeDialog,
}) => {
  const [className, setClassName] = useState('');
  const [loading, setLoading] = useState(false);
  const handleOnSubmit = async () => {
    await createNewClassOperations(
      branchId,
      buildingId,
      className,
      setLoading,
      closeDialog,
    );
  };
  return (
    <div>
      <EditText title={'שם הכיתה'} onChange={setClassName} />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'אישור'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
